'use client';

import { Subheading } from '@/components/catalyst/heading';
import { useSupaClient, useWorkspace } from '@/utils/clerk/client';
import { useDependentSWR } from '@/utils/hooks/useDependentSWR';
import { getOrgRecentConversations } from '@/utils/supabase/queries';
import ConversationsGrid from '../interview/conversation/ConversationPreviewGrid';

export default function Conversations({
  interviewId
}: {
  interviewId?: number;
}) {
  const { workspace } = useWorkspace();
  const supaClient = useSupaClient();

  const { data: conversations } = useDependentSWR(
    `/api/workspaces/${workspace?.id}`,
    () => getOrgRecentConversations(supaClient!, workspace!.id, interviewId),
    [supaClient, workspace]
  );

  if (!workspace || !conversations || conversations.length === 0) return null;

  return (
    <div>
      <Subheading>Recent Conversations</Subheading>
      <ConversationsGrid
        conversations={conversations}
        showInterviewName={true}
      />
    </div>
  );
}
